import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios, { API } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`);
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout, refetch: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function dashboardPathForRole(role) {
  if (role === "super_admin" || role === "admin" || role === "operator") return "/admin";
  if (role === "pembimbing") return "/panel-pembimbing";
  if (role === "agen") return "/agen";
  return "/jamaah";
}
